import React, { useEffect } from "react"

import ReactTableContainer from "../ReactTable"
import { TagsCell, TecnicalCell, UserAvatarInfo } from "../UserList"

import "./styles.scss"

const ContentRegisterList = ({ openModalEdit, data, loading, onSelect, selecteds }) => {

  const DateCell = ({ value }) => {
    return (
      <div className="date-cell align-cell">
        <span className="date-cell-label">{value}</span>
      </div>
    )
  }

  const NoteCell = ({ value }) => {
    return (
      <div className="date-cell align-cell">
        <span className="date-cell-label">{value || "0"}</span>
      </div>
    )
  }

  const StepCell = ({ value }) => {
    return (
      <div className="date-cell align-cell">
        <span className="date-cell-label">{value}</span>
      </div>
    )
  }

  const ObservationCell = ({ value }) => {
    return (
      <div className="observation-cell align-cell">
        <div className="observation-cell-label">{value}</div>
      </div>
    )
  }

  const ActionCell = ({ value }) => {
    return (
      <div className="action-cell align-cell">
        <button onClick={() => openModalEdit(value)}>
          Alterar
        </button>
      </div>
    )
  }

  const columns = [
    {
      Header: "Todos",
      width: "70",
      disableSortBy: true,
      className: "todos",
    },
    {
      Header: "Produtor",
      accessor: "Produtor",
      imgAccessor: "image",
      emailAccessor: "email",
      width: "270",
      minWidth: "270",
      Cell: UserAvatarInfo,
      disableSortBy: true
      
    },
    {
      Header: "Técnico",
      accessor: "Tecnico",
      width: "270",
      minWidth: "270",
      Cell: TecnicalCell,
      disableSortBy: true
    },
    {
      Header: "Data",
      accessor: "Inicio",
      width: "120",
      minWidth: "120",
      Cell: (value) => DateCell(value),
      disableSortBy: true
    },
    {
      Header: "Nota",
      accessor: "Pergunta_codigo.NOTA",
      width: "70",
      minWidth: "70",
      Cell: (value) => NoteCell(value),
    },
    {
      Header: "Etapa",
      accessor: "Etapa",
      width: "200",
      minWidth: "200",
      Cell: (value) => StepCell(value),
    },
    {
      Header: "Tags",
      accessor: "tag_user",
      Cell: TagsCell,
      width: "370",
      minWidth: "370",
      disableSortBy: true
    },
    {
      Header: "Observação",
      accessor: "Pergunta_codigo.TEMACONTEUDO",
      width: "250",
      width: "250",
      Cell: (value) => ObservationCell(value),
      disableSortBy: true
    },
    {
      Header: "Ação",
      width: "70",
      accessor: "ID",
      minWidth: "70",
      Cell: (value) => ActionCell(value),
      disableSortBy: true
    },
  ]

  return <ReactTableContainer onSelect={onSelect} canSelect={true} selecteds={selecteds} loadingTable={loading} columns={columns} data={data} keyCompare="ID" />
}

export default ContentRegisterList
